import React from "react";
import Utils from "../../helpers/Utils";
import _ from "lodash";

const Image = (props) => {
  const imgSrcSmall = Utils.image.getUrl(props.item, 400);
    const imgSrc = Utils.image.getUrl(props.item, 800);
    const altText = props.item?.["artifact.ingress.title"] + ' : ' + props.item?.["artifact.ingress.producer"]
    
  return (
    <div id="gallery-carousel-image" className="image">
      <img
        src={imgSrc}
        alt={altText}
        style={{
          objectFit: "contain",
          margin: "0 0",
        }}
      />
      <img
        src={imgSrcSmall}
        alt=''
        style={{
          position: "absolute",
          visibility: "hidden",
        }}
      />
      <img
        className="visually-hidden"
              src={imgSrc}
              alt=''
        style={{
          position: "absolute",
          opacity: 0,
          display: "none",
        }}
      />
    </div>
  );
};

export default Image;
